import React, { useState, useEffect } from "react";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import FormManagement from "./FormManagement/FormManagement.js";
import { useParams } from "react-router-dom";
import config from "config";
import StatusesManagement from "./StatusesManagement.js";
import ForDevelopers from "./ForDevelopers/ForDevelopers.js";
import OrderTracker from "./OrderTracker/OrderTracker.js";
import ActivityReports from "./ActivityReports/ActivityReports.js";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import getAsyncImage from "utils/getAsyncImage.js";
import SubUserEmbedErrorPage from "./SubUserEmbedErrorPage.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { defaultFormImages } from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";

import "./JumboEmbed.scss";

const JumboEmbed = ({ setActiveForDevelopersPage }) => {
  const {
    getUserData,
    isPremium,
    premiumExpired,
    fetchAllEmbedDynamicForms,
    getEmbedDynamicForms,
  } = useUser();
  const userData = getUserData();
  const { getTextByKey, getPath } = useContent();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [loadingForms, setLoadingForms] = useState(false);
  const [dynamicFormsList, setDynamicFormsList] = useState([]);
  const [emptyListForms, setEmptyListForms] = useState(false);
  const isActivityReportsPage = params.profilePage === "activity-reports";
  const [availableAllPages, setAvailableAllPages] = useState(
    isPremium() ? true : false
  );
  const [notExistEmbedPage, setNotExistEmbedPage] = useState(false);
  const [embedPageUserName, setEmbedPageUserName] = useState("");

  useEffect(() => {
    if (userData && userData.UserId !== undefined) {
      checkUserEmbedStatus(userData);
    }
  }, [userData]);

  const checkUserEmbedStatus = (user) => {
    if (user) {
      if (getEmbedDynamicForms() && getEmbedDynamicForms().length > 0) {
        //setDynamicFormsList(getEmbedDynamicForms());
        //setEmptyListForms(false);
        //setLoading(false);
        getAllEmbedDynamicForms();
      } else {
        getAllEmbedDynamicForms();
      }
      getEmbedPageByUserId();
    }
  };

  ///Get all embed Forms
  const getAllEmbedDynamicForms = async () => {
    setLoading(true);
    setLoadingForms(true);
    const parameters = {
      includePickerForm: isActivityReportsPage,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetAllEmbedFormsListReact",
      parameters
    );
    if (response.status === "success") {
      let tempList = [];
      for (let i = 0; i < response.data.length; i++) {
        const element = response.data[i];
        const callBackImage = (image) => {
          element.Embed_Dynamic_Image = image;
          tempList.push(element);
        };
        if (element.Embed_Dynamic_Image_Url) {
          //getAsyncImage
          if (
            !element.Embed_Dynamic_Image_Url.includes("/") &&
            !element.Embed_Dynamic_Image_Url.includes(
              `${config.api.resource}/assets/images/picker/picker-app.png`
            )
          ) {
            await getAsyncImage(
              `images/personal/form-images/webp/${element.Embed_Dynamic_Image_Url}.webp`,
              callBackImage
            );
          } else if (
            element.Embed_Dynamic_Image_Url.includes(
              `${config.api.resource}/assets/images/picker/picker-app.png`
            )
          ) {
            callBackImage(element.Embed_Dynamic_Image_Url);
          }
        } else {
          if (element.Embed_Dynamic_Image) {
            tempList.push(element);
          } else {
            await getAsyncImage(
              `images/${defaultFormImages[i]}.webp`,
              callBackImage
            );
          }
        }
      }
      setDynamicFormsList(tempList);
      fetchAllEmbedDynamicForms(tempList);
      if (response.data !== null) {
        if (response.data.length === 0) {
          if (!isPremium() && !premiumExpired()) {
            //here need to check if is first time in profile embed pages
          }
          setEmptyListForms(true);
        } else {
          setEmptyListForms(false);
        }
      }
      setLoading(false);
      setLoadingForms(false);
    } else {
      setEmptyListForms(true);
      setLoading(false);
      setLoadingForms(false);
    }
  };

  const getEmbedPageByUserId = async () => {
    setLoading(true);
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedDynamicPageByUserId"
    );
    if (response.status === "success") {
      if (response.data && response.data.EmbedPageUserName) {
        setEmbedPageUserName(response.data.EmbedPageUserName);
        setNotExistEmbedPage(false);
      } else {
        setNotExistEmbedPage(true);
      }
      setLoading(false);
    } else {
      setNotExistEmbedPage(true);
      setLoading(false);
    }
  };

  const renderPage = () => {
    if (!loading && !loadingForms) {
      if (getUserData() && getUserData().IsSubUser) {
        return <SubUserEmbedErrorPage />;
      }
      switch (params.profilePage) {
        case "":
        case undefined:
          window.location.href =
            config.baseurl + getPath() + "user/jumbo-forms/form-management";
          break;
        case "form-management":
          if (params.foid !== undefined) {
            return (
              <ActivityReports
                dynamicFormsList={dynamicFormsList}
                userData={getUserData()}
              />
            );
          }
          return (
            <FormManagement
              notExistEmbedPage={notExistEmbedPage}
              setNotExistEmbedPage={setNotExistEmbedPage}
              embedPageUserName={embedPageUserName}
              setEmbedPageUserName={setEmbedPageUserName}
              setDynamicFormsList={setDynamicFormsList}
              dynamicFormsList={dynamicFormsList}
              userData={getUserData()}
              emptyListForms={emptyListForms}
              setEmptyListForms={setEmptyListForms}
            />
          );
        case "for-developer":
          return (
            <ForDevelopers
              setActiveForDevelopersPage={setActiveForDevelopersPage}
              activeForDevelopersPage={{
                pageTitle: getTextByKey("api-title"),
                browserTitle: "api",
              }}
              userData={getUserData()}
            />
          );
        case "api":
          return (
            <ForDevelopers
              availableAllPages={availableAllPages}
              setActiveForDevelopersPage={setActiveForDevelopersPage}
              activeForDevelopersPage={{
                pageTitle: getTextByKey("api-title"),
                browserTitle: "api",
              }}
              userData={getUserData()}
            />
          );
        case "ftp":
          return (
            <ForDevelopers
              availableAllPages={availableAllPages}
              setActiveForDevelopersPage={setActiveForDevelopersPage}
              activeForDevelopersPage={{
                pageTitle: getTextByKey("ftp-title"),
                browserTitle: "ftp",
              }}
              userData={getUserData()}
            />
          );
        case "integration":
          return (
            <ForDevelopers
              setActiveForDevelopersPage={setActiveForDevelopersPage}
              activeForDevelopersPage={{
                pageTitle: getTextByKey("integration-title"),
                browserTitle: "integration",
              }}
              userData={getUserData()}
            />
          );
        case "statuses-management":
          return (
            <StatusesManagement
              availableAllPages={availableAllPages}
              userData={getUserData()}
            />
          );

        case "order-tracker":
          return (
            <OrderTracker
              dynamicFormsList={dynamicFormsList}
              availableAllPages={availableAllPages}
              userData={getUserData()}
            />
          );
        case "activity-reports":
          return (
            <ActivityReports
              userData={getUserData()}
              dynamicFormsList={dynamicFormsList}
            />
          );
        default:
          window.location.href = config.baseurl + getPath() + "error";
          break;
      }
    }
  };

  return (
    <>
      {!loading && !loadingForms ? (
        <div
          className={`embed-container ${
            notExistEmbedPage &&
            dynamicFormsList.length > 0 &&
            params.profilePage === "form-management"
              ? "form-management-special-header"
              : ""
          }`}
        >
          {renderPage()}
        </div>
      ) : (
        <div className="loading-embed">
          <LoadingImageElement />
        </div>
      )}
    </>
  );
};

export default JumboEmbed;
